import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
/* import { Mensaje, MensajeSiNo } from "../mensajes"; */
import { Loader, Dimmer, Label } from "semantic-ui-react";
import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
  validaNumeroTelefono,
  validaEmail,
  validaSoloLetras,
} from "../../util/varios";

import axios from "axios";
import moment from "moment";
import { Mensaje } from "../mensajes";
import CatalogoClientes from "../../catalogos/catalogoClientes";

export const ModalLicencia = (props) => {
  /*  variables de estados */

  let op = require("../../modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const dolarbcv = JSON.parse(localStorage.getItem("dolarbcv"));
  const user = JSON.parse(localStorage.getItem("username"));
  const sucursal = JSON.parse(localStorage.getItem("sucursal"));
  const ID = useRef();
  const idCliente = useRef();
  const idCobertura = useRef();
  const txtNombre = useRef();
  const txtTipoSangre = useRef();
  const txtCedula = useRef();
  const cmbTipoLicencia = useRef();
  const cmbPago = useRef();
  const cmbNacionalidad = useRef();
  const cmbTelefono = useRef();
  const txtTelefono = useRef();
  const txtReferencia = useRef();
  const txtTotal = useRef();
  const txtDolar = useRef();
  const cmbLentes = useRef();
  const txtAbono = useRef();
  const txtCorreo = useRef();
  const txtApellido = useRef();
  const txtRestante = useRef();
  const check1 = useRef();
  const check2 = useRef();
  const check3 = useRef();
  const check4 = useRef();
  const [values, setValues] = useState({
    ced: "",
    nombre: "",
    apellido: "",
    fecha_nac: "",
    bas_agua: 1,
    status: 1,
    bas_espirit: 1,
    cod_iglesia: "",
    sexo: "M",
    fecha_baus: "",
    nacionalidad: "V",
    direccion: "",
    telefono: "",
    celular: "",
    estadocivil: 0,
    correo: "",
    tiposangre: "",
  });

  const btnCancela = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const btnAcepta = useRef();

  const [activate, setActivate] = useState(false);
  const [mostrar, setMostrar] = useState(false);

  const [operacion, setOperacion] = useState(0);

  /*********************************************** FUNCINES DE VALIDACION***********************************************************/
  const handleTipoSangreChange = (event) => {
    event.preventDefault();
    const inputValue = event.target.value;
    const sanitizedValue = inputValue.replace(/[^a-zA-Z+-]/g, ""); // Mantener solo letras, + y -

    event.target.value = sanitizedValue;
    // Luego puedes hacer algo con el valor validado, como establecerlo en el estado local.
  };
  const handleFormaPagoChange = () => {
    const selectedOption = cmbPago.current.value;

    // Si la opción seleccionada es "Efectivo" o "Punto", deshabilita el input de referencia; de lo contrario, habilítalo.
    if (selectedOption === "1" || selectedOption === "3") {
      txtReferencia.current.disabled = true;
      txtReferencia.current.value = "";
    } else {
      txtReferencia.current.disabled = false;
    }
  };

  const salir = () => {
    props.onHideCancela();
    setValues({
      ced: "",
      nombre: "",
      apellido: "",
      fecha_nac: "",
      bas_agua: 1,

      status: 1,
      bas_espirit: 1,
      cod_iglesia: "",
      sexo: "M",
      fecha_baus: "",
      nacionalidad: "V",
      direccion: "",
      telefono: "",
      celular: "",
      estadocivil: 0,
      correo: "",
      tiposangre: "",
    });
  };
  const seleccionarRegistros = async (id) => {
    if (id === "") return false;
    let endpoint = op.conexion + "/Licencia/ConsultarUno";
    console.log(endpoint);
    let bodyF = new FormData();
    bodyF.append("ID", id);
    await fetch(endpoint, {
      method: "POST",
      body: bodyF,
    })
      .then((res) => res.json())
      .then((response) => {
        setActivate(false);
        ID.current.value = response[0].licencia_id;
        idCliente.current.value = response[0].cliente_id;
        idCobertura.current.value = response[0].nota_id;
        var cedula = response[0].cliente_cedula.split("-");
        cmbNacionalidad.current.value = cedula[0] + "-";
        txtCedula.current.value = cedula[1];
        txtNombre.current.value = response[0].cliente_nombre;
        txtApellido.current.value = response[0].cliente_apellido;
        txtCorreo.current.value = response[0].licencia_correo;
        var telefono = response[0].cliente_telefono.split("-");
        if (telefono[0] != "" && telefono[1] != "") {
          cmbTelefono.current.value = telefono[0] + "-";
          txtTelefono.current.value = telefono[1];
        } else {
          cmbTelefono.current.value = "0414-";
          txtTelefono.current.value = "";
        }

        txtTipoSangre.current.value = response[0].licencia_sangre;
        cmbTipoLicencia.current.value = response[0].licencia_licencia;
        check1.current.checked = response[0].licencia_licenciaRestante
          ? response[0].licencia_licenciaRestante.substring(0, 1) == "1"
            ? true
            : false
          : false;
        check2.current.checked = response[0].licencia_licenciaRestante
          ? response[0].licencia_licenciaRestante.substring(1, 2) == "1"
            ? true
            : false
          : false;
        check3.current.checked = response[0].licencia_licenciaRestante
          ? response[0].licencia_licenciaRestante.substring(2, 3) == "1"
            ? true
            : false
          : false;
        check4.current.checked = response[0].licencia_licenciaRestante
          ? response[0].licencia_licenciaRestante.substring(3, 4) == "1"
            ? true
            : false
          : false;
        cmbLentes.current.value = response[0].licencia_lente;
        cmbPago.current.value = response[0].nota_tipoPago;
        txtReferencia.current.value = response[0].nota_referencia;
        txtTotal.current.value = response[0].licencia_montoTotal;
        txtAbono.current.value = response[0].licencia_abonado;
        txtRestante.current.value = response[0].licencia_restante;
      })
      .catch((error) =>
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: error.res,
          icono: "informacion",
        })
      );
  };
  const actualizarCertificado = async () => {
    let endpoint = "";
    if (props.operacion === 2) {
      endpoint = op.conexion + "/Licencia/Editar";
    } else {
      endpoint = op.conexion + "/poliza/registrarLicencia";
    }
    console.log(endpoint);
    setActivate(true);
    let bodyF = new FormData();

    let chk1 = check1.current.checked ? "1" : "0";
    let chk2 = check2.current.checked ? "1" : "0";
    let chk3 = check3.current.checked ? "1" : "0";
    let chk4 = check4.current.checked ? "1" : "0";
    let permiso = chk1 + chk2 + chk3 + chk4;
    bodyF.append("ID", ID.current.value);
    bodyF.append("idCliente", idCliente.current.value);
    bodyF.append("Cobertura", idCobertura.current.value);
    bodyF.append("precioDolar", dolarbcv);
    bodyF.append("Nombre", txtNombre.current.value);
    bodyF.append("Apellido", txtApellido.current.value);
    bodyF.append(
      "Cedula",
      cmbNacionalidad.current.value + txtCedula.current.value
    );
    bodyF.append(
      "Telefono",
      cmbTelefono.current.value + txtTelefono.current.value
    );
    bodyF.append("tipoSangre", txtTipoSangre.current.value);
    bodyF.append("Correo", txtCorreo.current.value);
    bodyF.append("correoLicencia", txtCorreo.current.value);
    bodyF.append("Licencia", cmbTipoLicencia.current.value);
    bodyF.append("licenciaRestante", permiso);
    bodyF.append("montoTotal", txtTotal.current.value);
    bodyF.append("Abonado", txtAbono.current.value);
    bodyF.append("Restante", txtRestante.current.value);
    bodyF.append("cantidadDolar", txtTotal.current.value);
    bodyF.append("metodoPago", cmbPago.current.value);
    bodyF.append("Referencia", txtReferencia.current.value);
    bodyF.append("Lente", cmbLentes.current.value);
    bodyF.append("Usuario", user);
    bodyF.append("Sucursal", sucursal);
    bodyF.append("token", token);
    await fetch(endpoint, {
      method: "POST",
      body: bodyF,
    })
      .then((res) => res.json())
      .then((response) => {
        setActivate(false);
        console.log(response);
        if (response.code == 400) {
          setMensaje({
            mostrar: true,
            titulo: "Error.",
            texto: response.res,
            icono: "error",
          });
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Registro Guardado Exitosamente",
            icono: "exito",
          });
        }
      })
      .catch((error) =>
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: error.res,
          icono: "informacion",
        })
      );
  };

  const onChangeValidar = () => {
    let sigue = true;
    let minimo = 0;
    let calculo = 0;

    /*  else if( && operacion === 1){
          setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Ya existe un usuario con este n° de cedula",
              icono: "informacion",
            });
            sigue = false;
            txtCedula.current.focus()
  
      } */

    if (sigue) {
      actualizarCertificado();
    }
  };

  const blanquear = () => {
    setValues({
      ced: "",
      nombre: "",
      apellido: "",
      fecha_nac: "",
      bas_agua: 1,

      status: 1,
      bas_espirit: 1,
      cod_iglesia: "",
      sexo: "M",
      fecha_baus: "",
      nacionalidad: "V",
      direccion: "",
      telefono: "",
      celular: "",
      estadocivil: 0,
      correo: "",
      tiposangre: "",
    });
  };

  /*const check = (e) => {
    var textV = "which" in e ? e.which : e.keyCode,
      char = String.fromCharCode(textV),
      regex = /[a-z]/ig;
    if (!regex.test(char)) e.preventDefault(); return false;
  }*/
  const seleccionarCliente = (
    nombre,
    apellido,
    cedula,
    nacionalidad,
    correo,
    codigo,
    telefono
  ) => {
    console.log(codigo);
    cmbNacionalidad.current.value = nacionalidad + "-";
    txtCedula.current.value = cedula;
    txtApellido.current.value = apellido;
    txtNombre.current.value = nombre;
    cmbTelefono.current.value = codigo + "-";
    txtTelefono.current.value = telefono;
    // let item = document.getElementById("ced");
    // item.classList.remove("form-text", "fw-bold", "visible");
    // item.classList.add("form-text", "fw-bold", "hidden");

    setMostrar(false);
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideCancela();
  };

  const actualizarValores = (tipoLicenciaValue, abonoValue) => {
    let totalValue = 0;
    let restanteValue = 0;

    if (tipoLicenciaValue === "0" || tipoLicenciaValue === "1") {
      totalValue = 20.0;
    } else if (tipoLicenciaValue === "2" || tipoLicenciaValue === "3") {
      totalValue = 25.0;
    }

    restanteValue = (totalValue - abonoValue).toFixed(2);
    console.log("Abono Value:", abonoValue);
    txtTotal.current.value = totalValue.toFixed(2);
    txtRestante.current.value = restanteValue;
  };

  const handleTipoLicenciaChange = () => {
    const selectedValue = cmbTipoLicencia.current.value;
    const abonoValue = parseFloat(txtAbono.current.value) || 0; // Convertir a número o 0 si no es un número
    actualizarValores(selectedValue, abonoValue);
  };

  function soloLetras(event) {
    if (
      (event.keyCode != 32 && event.keyCode < 65) ||
      (event.keyCode > 90 && event.keyCode < 97) ||
      event.keyCode > 122
    )
      event.returnValue = false;
  }

  const consultarCliente = async ($cedula) => {
    let endpoint = op.conexion + "/cliente/consultarCedulaCliente";
    let bodyF = new FormData();
    bodyF.append("cedula", $cedula);
    setActivate(true);
    await fetch(endpoint, {
      method: "POST",
      body: bodyF,
    })
      .then((res) => res.json())
      .then((response) => {
        setActivate(false);
        if (response.code == 400) {
          setMensaje({
            mostrar: true,
            titulo: "Error.",
            texto: response.res,
            icono: "error",
          });
        } else {
          txtNombre.current.value = response.cliente.cliente_nombre;
          txtApellido.current.value = response.cliente.cliente_apellido;
          let telefono = response.cliente.cliente_telefono.split("-");
          if (telefono[1] == null) {
            cmbTelefono.current.value = "0412-";
            txtTelefono.current.value = "";
          } else {
            cmbTelefono.current.value = telefono[0] + "-";
            txtTelefono.current.value = telefono[1];
          }
        }
      })
      .catch((error) =>
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: error.res,
          icono: "informacion",
        })
      );
  };
  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  return (
    <Modal
      {...props}
      style={{ background: "rgb(28, 27, 23)" }}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        console.log(props);
        if (props.operacion) {
          seleccionarRegistros(props.idLicencia);
        }
      }}
    >
      <Modal.Header className="bg-danger">
        <Modal.Title style={{ color: "#fff" }}>
          {props.operacion === 2 ? "Editar Licencia" : "Registrar Licencia"}
        </Modal.Title>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={salir}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ color: "rgb(106, 115, 123)" }}>
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <CatalogoClientes
          show={mostrar}
          onHideCancela={() => {
            setMostrar(false);
          }}
          onHideCatalogo={seleccionarCliente}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />

        <div className="col-md-12 row mx-auto">
          <div class="input-group input-group-sm mb-3 col-md-5">
            <span class="input-group-text" id="inputGroup-sizing-sm">
              Cedula:
            </span>
            <input type="hidden" ref={idCobertura} />
            <input type="hidden" ref={idCliente} />
            <input type="hidden" ref={ID} />
            <select
              class="form-select col-md-3"
              ref={cmbNacionalidad}
              aria-label="Default select example"
            >
              <option value="V-">V-</option>
              <option value="E-">E-</option>
              <option value="J-">J-</option>
              <option value="G-">G-</option>
            </select>
            <input
              maxLength={9}
              type="text"
              class="form-control"
              ref={txtCedula}
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              onChange={validaSoloNumero}
            />
            <button
              type="button"
              class="btn btn-success"
              onClick={() =>
                consultarCliente(
                  cmbNacionalidad.current.value + txtCedula.current.value
                )
              }
            >
              <i class="fa fa-search"></i>
            </button>
          </div>
          <div class=" col-md-7"></div>
          <div class="input-group input-group-sm mb-3 col-md-6">
            <span class="input-group-text" id="inputGroup-sizing-sm">
              Nombres:
            </span>
            <input
              maxLength={25}
              type="text"
              class="form-control"
              onKeyDown={validaSoloLetras}
              onChange={(e) => {
                e.target.value = e.target.value.toUpperCase();
              }}
              ref={txtNombre}
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>
          <div class="input-group input-group-sm mb-3 col-md-6">
            <span class="input-group-text" id="inputGroup-sizing-sm">
              Apellidos:
            </span>
            <input
              maxLength={25}
              type="text"
              class="form-control"
              ref={txtApellido}
              onKeyDown={validaSoloLetras}
              onChange={(e) => {
                e.target.value = e.target.value.toUpperCase();
              }}
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
            />
          </div>
          <div class="input-group input-group-sm mb-3 col-md-4">
            <span class="input-group-text" id="inputGroup-sizing-sm">
              Correo:
            </span>
            <input
              maxLength={30}
              type="text"
              class="form-control"
              ref={txtCorreo}
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              onChange={(e) => {
                e.target.value = e.target.value.toUpperCase();
              }}
            />
          </div>
          <div class="input-group input-group-sm mb-3 col-md-5">
            <span class="input-group-text" id="inputGroup-sizing-sm">
              Telefono
            </span>
            <select
              class="form-select col-md-4"
              ref={cmbTelefono}
              aria-label="Default select example"
            >
              <option value="0414-">0414</option>
              <option value="0424-">0424</option>
              <option value="0416-">0416</option>
              <option value="0426-">0426</option>
              <option value="0412-">0412</option>
            </select>
            <input
              type="text"
              class="form-control"
              maxLength={7}
              ref={txtTelefono}
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              onChange={validaSoloNumero}
            />
          </div>
          <div class="input-group input-group-sm mb-3 col-md-3">
            <span class="input-group-text" id="inputGroup-sizing-sm">
              Tipo de Sangre:
            </span>
            <select
              class="form-select col-md-6"
              ref={txtTipoSangre}
              aria-label="Default select example"
            >
               <option value="N/S">N/S</option>
              <option value="A+">A+</option>
              <option value="A-">A-</option>
              <option value="B+">B+</option>
              <option value="B-">B-</option>
              <option value="AB+">AB+</option>
              <option value="AB-">AB-</option>
              <option value="O+">O+</option>
              <option value="O-">O-</option>
            </select>
          </div>
          <div class="input-group input-group-sm mb-3 col-md-4">
            <span class="input-group-text" id="inputGroup-sizing-sm">
              Tipo De Licencia:
            </span>
            <select
              class="form-select"
              ref={cmbTipoLicencia}
              aria-label="Default select example"
              onChange={handleTipoLicenciaChange}
            >
              <option value=" ">Seleccionar</option>
              <option value="0">Licencia de 2da</option>
              <option value="1">Licencia de 3da</option>
              <option value="2">Licencia de 4da</option>
              <option value="3">Licencia de 5da</option>
            </select>
          </div>
          <div className="col-md-4 mx-auto row">
            <div class="form-check col my-auto">
              <input
                class="form-check-input my-auto"
                ref={check1}
                type="checkbox"
                value="0"
                id="flexCheckDefault"
              />
              <label class="form-check-label my-auto">2da</label>
            </div>
            <div class="form-check col my-auto">
              <input
                class="form-check-input my-auto"
                ref={check2}
                type="checkbox"
                value="1"
                id="flexCheckDefault"
              />
              <label class="form-check-label my-auto">3ra</label>
            </div>
            <div class="form-check col my-auto">
              <input
                class="form-check-input my-auto"
                ref={check3}
                type="checkbox"
                value="2"
                id="flexCheckDefault"
              />
              <label class="form-check-label my-auto">4ta</label>
            </div>
            <div class="form-check col my-auto">
              <input
                class="form-check-input my-auto"
                ref={check4}
                type="checkbox"
                value="3"
                id="flexCheckDefault"
              />
              <label class="form-check-label my-auto">5ta</label>
            </div>
          </div>
          <div class="input-group input-group-sm mb-3 col-md-3">
            <span class="input-group-text" id="inputGroup-sizing-sm">
              Usa lentes:
            </span>
            <select
              class="form-select"
              ref={cmbLentes}
              aria-label="Default select example"
            >
              <option value="0">No</option>
              <option value="1">Si</option>
            </select>
          </div>
          <div class="input-group input-group-sm mb-3 col-md-5">
            <span class="input-group-text" id="inputGroup-sizing-sm">
              Forma de Pago:
            </span>
            <select
              class="form-select"
              ref={cmbPago}
              aria-label="Default select example"
              onChange={handleFormaPagoChange}
            >
              <option value="0">Pago Movil</option>
              <option value="1">Efectivo</option>
              <option value="2">Transferencia</option>
              <option value="3">Punto</option>
            </select>
          </div>
          <div class="input-group input-group-sm mb-3 col-md-4">
            <span class="input-group-text" id="inputGroup-sizing-sm">
              Referencia:
            </span>
            <input
              maxLength={4}
              type="text"
              class="form-control"
              ref={txtReferencia}
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              onChange={validaSoloNumero}
            />
          </div>
          <div class="input-group input-group-sm mb-3 col-md-3">
            <span class="input-group-text" id="inputGroup-sizing-sm">
              Total:
            </span>
            <input
              type="text"
              class="form-control text-right"
              ref={txtTotal}
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              disabled
              onChange={handleInputMontoChange}
            />
          </div>
          <div class=" col-md-2"></div>
          <div class="input-group input-group-sm mb-3 col-md-4">
            <span class="input-group-text" id="inputGroup-sizing-sm">
              Abono:
            </span>
            <input
              type="text"
              class="form-control text-right"
              ref={txtAbono}
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              onChange={validaSoloNumero}
              onKeyUp={handleTipoLicenciaChange}
            />
          </div>
          <div class="input-group input-group-sm mb-3 col-md-4">
            <span class="input-group-text" id="inputGroup-sizing-sm">
              Restante:
            </span>
            <input
              disabled
              type="text"
              class="form-control text-right"
              ref={txtRestante}
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              onChange={handleInputMontoChange}
              onKeyDown={validaSoloNumero}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill col-md-2"
          disabled={props.operacion === 4 ? true : false}
          onClick={onChangeValidar}
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={salir}
          className="btn btn-sm btn-danger rounded-pill col-md-2"
        >
          <i className="fas fa-window-close"> Salir</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};
